// ============================================================================
// AppLayout - Shared Layout Shell for All Authenticated Pages
// Provides corporate EduPath branding (header + footer) around page content
// ============================================================================

import React from 'react';
import { Outlet } from 'react-router-dom';
import AppHeader from './AppHeader';
import AppFooter from './AppFooter';
import OfflineBanner from '@/components/shared/OfflineBanner';

const AppLayout: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen">
      <OfflineBanner />
      <AppHeader />
      <main className="flex-1">
        {children || <Outlet />}
      </main>
      <AppFooter />
    </div>
  );
};

export default AppLayout;
